import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'
import {
  GET_TYPE_OPERATION,
  GET_TYPE_OPERATION_EXITO
} from '../types/typeOperationActionstypes'

export type TypeOperationActions =
  | TypeOperationAction
  | TypeOperationActionAsync

// Esto va a REDUX
export interface TypeOperationAction {
  type: typeof GET_TYPE_OPERATION_EXITO
  typeOperation: TypeOperation[] | undefined
  error: string | undefined
}

export const getTypeOperationAction = (
  typeOperation?: TypeOperation[],
  error?: string
): TypeOperationActions => {
  return {
    type: GET_TYPE_OPERATION_EXITO,
    typeOperation,
    error
  }
}

// Esto va a SAGA
export interface TypeOperationActionAsync {
  type: typeof GET_TYPE_OPERATION
}

export const getTypeOperationActionAsync = (): TypeOperationActionAsync => {
  return {
    type: GET_TYPE_OPERATION
  }
}
